import React from 'react';
import * as analytics from '../lib/analytics';

export default class extends React.Component {
  handleClick = event => {
    event.preventDefault();
  };

  handleFBClick = socialShareType => {
    let social = this.props.campaignInfo.templateData.social;
    let fbShareMsg = (social && social.fbShareMsg.split(' ')) || [];

    let storeFbShareMsg = fbShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    fbShareMsg = storeFbShareMsg.join(' ');

    let name = social.fbShareName;
    let link = this.props.campaignInfo.eventUrl;
    let caption = social.fbShareCaption;
    let picture = social.fbShareLogoUrl.startsWith('http') ?
      social.fbShareLogoUrl :
      '';
    let appId = '321983581337375';

    let constructUrl = `https://www.facebook.com/dialog/feed?app_id=${appId}&name=${name}&display=popup&caption=${caption}&description=${fbShareMsg}&picture=${picture}&link=${link}`;

    window.open(
      constructUrl,
      'facebook',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );

    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleAnalytics = socialShareType => {
    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  render() {
    let social = this.props.campaignInfo.templateData.social;
    let twitterShareMsg =
      (social && social.twitterShareMsg && social.twitterShareMsg.split(' ')) ||
      [];
    let mailShareMsg =
      (social && social.mailShareMsg && social.mailShareMsg.split(' ')) || [];

    let storeTwitterShareMsg = twitterShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    let storeMailShareMsg = mailShareMsg.map((text, index) => {
      return encodeURIComponent(text);
    });

    twitterShareMsg = storeTwitterShareMsg.join(' ');
    mailShareMsg = storeMailShareMsg.join(' ');

    let twitterUrl =
      'https://twitter.com/intent/tweet?url=www.paypal.com&text=' +
      twitterShareMsg;
    let mailUrl = 'mailto:?subject=Donate with PayPal!&body=' + mailShareMsg;

    return (
      <div className='share'>
        <ul>
          <If condition={this.props.campaignInfo.templateData.social.fb}>
            <li className='facebook' data-testid='social-facebook'>
              <a onClick={this.handleFBClick.bind(this, 'facebookshare')}>
                Facebook
              </a>
            </li>
          </If>
          <If condition={this.props.campaignInfo.templateData.social.twitter}>
            <li className='twitter' data-testid='social-twitter'>
              <a
                onClick={this.handleAnalytics.bind(this, 'twittershare')}
                href={twitterUrl}
                target='_blank'
              >
                Twitter
              </a>
            </li>
          </If>
          <If condition={this.props.campaignInfo.templateData.social.mail}>
            <li className='email' data-testid='social-email'>
              <a
                onClick={this.handleAnalytics.bind(this, 'mailshare')}
                href={mailUrl}
              >
                Email
              </a>
            </li>
          </If>
        </ul>
      </div>
    );
  }
}

class If extends React.Component {
  static displayName = 'If';

  render() {
    if (this.props.condition === 'yes') {
      return <span>{this.props.children}</span>;
    }
    return null;
  }
}
